import React, { useEffect } from "react";
import {
  Box,
  Button,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useForm } from "react-hook-form";

import ReuseableLabel from "../Components/ReusableComponents/ReuseableLabel";
import { removePlusFromPhoneNumber } from "../utils/helperFunctions";

const PeopleToNotifyRepeater = ({
  formValues = [],
  setFormValues,
  disable = false,
  newSubmit,
  countryDetails = [],
  countrySelected,
  repeaterError,
  setRepeaterError,
}) => {
  const initialState = [
    {
      cname: "",
      cphone: "",
      email: "",
      cphonecode: "",
    },
  ];

  useForm({
    defaultValues: initialState,
  });

  useEffect(() => {
    if (formValues?.length > 0 && formValues[0]?.cphonecode === "") {
      const updatedValues = [...formValues];

      updatedValues[0].cphonecode = removePlusFromPhoneNumber(countrySelected);

      setFormValues(updatedValues);
    }
  }, []);

  const handleChange = (index, field, value) => {
    const updatedFormValues = [...formValues];

    updatedFormValues[index] = {
      ...updatedFormValues[index],
      [field]: value,
    };

    setFormValues(updatedFormValues);
  };

  const addFormFields = () => {
    setRepeaterError(false);

    setFormValues([
      ...formValues,
      {
        cname: "",
        cphone: "",
        email: "",
        cphonecode: removePlusFromPhoneNumber(countrySelected),
      },
    ]);
  };

  const removeFormFields = (index) => {
    const updatedFormValues = [...formValues];

    updatedFormValues.splice(index, 1);

    setFormValues(updatedFormValues);
  };

  return (
    <Stack sx={{ width: "100%" }}>
      {formValues?.map((element, index) => (
        <Stack direction="column" key={`notify-person-${index}`}>
          <Typography
            sx={{
              fontWeight: 600,
              color: "primary.darkText",
              fontFamily: "sans-serif",
              mb: "5px",
              mt: "10px",
            }}
          >
            People to be notified :
          </Typography>

          {/* NAME */}
          <TextField
            fullWidth
            label={<ReuseableLabel label={"Name"} />}
            name="cname"
            variant="outlined"
            value={element.cname}
            disabled={disable}
            onChange={(e) => handleChange(index, "cname", e.target.value)}
            sx={{ marginBottom: "10px" }}
            error={repeaterError && element.cname === ""}
            helperText={
              repeaterError && element.cname === "" ? "Name required" : ""
            }
          />

          <Stack
            direction={{ xs: "column", md: "row" }}
            sx={{ width: "100%" }}
            gap={2}
          >
            {/* PHONE SECTION */}
            <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
              <Select
                id={`phone_flag_${index}`}
                labelId={`phone_flag_label_${index}`}
                name="cphonecode"
                disabled={disable}
                sx={{
                  minWidth: "90px",
                  height: "56px",
                }}
                value={
                  element.cphonecode ||
                  removePlusFromPhoneNumber(countrySelected)
                }
                onChange={(e) =>
                  handleChange(index, "cphonecode", e.target.value)
                }
              >
                {countryDetails?.map((res, idx) => {
                  const flagstr = res.iso2 === "UM" ? "US" : res.iso2;

                  const code = `https://catamphetamine.github.io/country-flag-icons/3x2/${flagstr}.svg`;

                  const phone_code = res.phone_code.includes("+")
                    ? res.phone_code
                    : `+${res.phone_code}`;

                  return (
                    <MenuItem
                      key={`${res.iso2}-${res.phone_code}-${idx}`}
                      value={res.phone_code}
                      sx={{
                        borderBottom:
                          idx !== countryDetails.length - 1
                            ? "1px solid #f0f0f0"
                            : "none",
                      }}
                    >
                      <img
                        src={code}
                        width="25"
                        style={{
                          marginRight: "6px",
                        }}
                        alt={res.name}
                      />

                      {phone_code}
                    </MenuItem>
                  );
                })}
              </Select>

              <TextField
                fullWidth
                label={<ReuseableLabel label="Phone #" />}
                name="cphone"
                variant="outlined"
                value={element.cphone}
                disabled={disable}
                inputProps={{
                  maxLength: 15,
                }}
                onChange={(e) => handleChange(index, "cphone", e.target.value)}
                error={repeaterError && element.cphone === ""}
                helperText={
                  repeaterError && element.cphone === "" ? "Phone required" : ""
                }
              />
            </Stack>

            {/* EMAIL */}
            <TextField
              fullWidth
              label={<ReuseableLabel label="Email" />}
              name="email"
              type="email"
              disabled={disable}
              inputProps={{
                pattern:"[a-z0-9._%+\\-]+@[a-z0-9.\\-]+\\.[a-z]{2,}$",
                title: "Enter a valid email address",
              }}
              variant="outlined"
              value={element.email}
              onChange={(e) => handleChange(index, "email", e.target.value)}
              error={repeaterError && element.email === ""}
              helperText={
                repeaterError && element.email === "" ? "Email required" : ""
              }
            />
          </Stack>

          {/* ACTION BUTTONS */}
          <Stack direction="row" alignItems="center" gap={2}>
            {formValues.length === index + 1 && (
              <Button
                sx={{
                  height: "40px",
                  borderRadius: "6px",
                  marginTop: "10px",
                  backgroundColor: "primary.main",
                  color: "#fff",
                  textTransform: "none",

                  "&:hover": {
                    backgroundColor: "primary.dark",
                  },
                }}
                type="button"
                disabled={disable}
                onClick={addFormFields}
              >
                Add more
              </Button>
            )}

            {index > 0 && (
              <Button
                sx={{
                  height: "40px",
                  borderRadius: "6px",
                  marginTop: "10px",
                  textTransform: "none",
                  backgroundColor: "secondary.main",
                  color: "#fff",

                  "&:hover": {
                    backgroundColor: "secondary.dark",
                  },
                }}
                type="button"
                disabled={disable}
                onClick={() => removeFormFields(index)}
              >
                Remove
              </Button>
            )}
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};

export default PeopleToNotifyRepeater;
